export const fixHover = () => {
	let el = this;
	let par = el.parentNode;
	let next = el.nextSibling;
	par.removeChild(el);
	setTimeout(() => {
		par.insertBefore(el, next);
	}, 0);
};

export const focusBlur = () => {
	document.activeElement.blur();
};
